export const CLEAR_REVISION_IMPORT = 'app/ImportRevision/CLEAR_REVISION_IMPORT'
export const UPLOAD_FILE = 'app/ImportRevision/UPLOAD_FILE'
export const UPLOAD_FILE_DONE = 'app/ImportRevision/UPLOAD_FILE_DONE'
export const UPLOAD_FILE_ERROR = 'app/ImportRevision/UPLOAD_FILE_ERROR'
export const COMPARE_RESOLUTION = 'app/ImportRevision/COMPARE_RESOLUTION'
export const COMPARE_RESOLUTION_DONE =
  'app/ImportRevision/COMPARE_RESOLUTION_DONE'
export const COMPARE_RESOLUTION_ERROR =
  'app/ImportRevision/COMPARE_RESOLUTION_ERROR'
export const IMPORT_REVISION = 'app/ImportRevision/IMPORT_REVISION'
export const IMPORT_REVISION_DONE = 'app/ImportRevision/IMPORT_REVISION_DONE'
export const IMPORT_REVISION_ERROR = 'app/ImportRevision/IMPORT_REVISION_ERROR'
export const LOAD_PLAN = 'app/ImportRevision/LOAD_PLAN'
export const LOAD_PLAN_ERROR = 'app/ImportRevision/LOAD_PLAN_ERROR'
export const PLAN_LOADED = 'app/ImportRevision/PLAN_LOADED'

export const START_GENERATE_OVERLAY =
  'app/ImportRevision/START_GENERATE_OVERLAY'
export const GENERATE_OVERLAY_ERROR =
  'app/ImportRevision/GENERATE_OVERLAY_ERROR'
export const GENERATE_OVERLAY_DONE = 'app/ImportRevision/GENERATE_OVERLAY_DONE'
export const GENERATE_FIRST_OVERLAY_DONE =
  'app/ImportRevision/GENERATE_FIRST_OVERLAY_DONE'

export const GET_GENERATE_OVERLAY_STATUS =
  'app/ImportRevision/GET_GENERATE_OVERLAY_STATUS'

export const UNKNOWN_ERROR = 'An unknown error occurred'

export const generateOverlayTypes = {
  FILE: 'FILE',
  REVISION: 'REVISION'
}

export const convertSuggestionTypes = {
  PDF_TO_IMAGE: 'PDF_TO_IMAGE',
  IMAGE_TO_PDF: 'IMAGE_TO_PDF'
}
